import { AxiosError } from "axios"

import { datadogRum } from "@datadog/browser-rum"

import { ErrorsObject } from "./components/field/field-errors"
import { config } from "./config"
import { FormField } from "./models"

export const validateFileFormat = (files: FileList) => {
  const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"]

  let filesValid = true

  for (let i = 0; i < files.length; i++) {
    if (!allowedFileTypes.includes(files[i].type)) {
      filesValid = false
    }
  }

  return filesValid
}

export const logDatadogRumError = (
  error: Error,
  axiosError: AxiosError,
  data?: { [key: string]: any },
) => {
  if (axiosError.response?.status !== 403) {
    datadogRum.addError(error, {
      axiosError,
      data,
    })
  }
}

const findFirstFieldWithError = (
  errors: ErrorsObject,
  fields: FormField[],
): string | undefined => {
  if (!errors || !fields) return

  return Object.keys(errors).find((error) =>
    fields.find((field) => field.field === error),
  )
}

export const focusFieldWithError = (propertyId: string): void => {
  const htmlElement: HTMLElement | null = document.querySelector(
    `[data-property-name="${propertyId}"]`,
  )

  if (!htmlElement) {
    return
  }

  const innerElementWithId: HTMLElement | null = htmlElement.querySelector(
    `[id="field_${propertyId}"]`,
  )

  if (innerElementWithId) {
    innerElementWithId.focus({ preventScroll: true })
    htmlElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    })
  }
}

export const focusFirstFieldWithError = (errors: ErrorsObject, fields: FormField[]) => {
  const firstFieldId = findFirstFieldWithError(errors, fields)
  if (!firstFieldId) return

  focusFieldWithError(firstFieldId)
}

export const redirectToBackOffice = (): void => {
  window.location.replace(config.portalUrl)
}
